/**
 * @description This hook retrieves the knowledge entries from the backend
 */

import React from 'react';
import { useQuery } from '@tanstack/react-query';

import fetchKnowledge from '../queries/fetchKnowledge';

const useKnowledge = () => {
  // Indicates which category is currently selected
  const [selectedCategory, setSelectedCategory] = React.useState(null);

  const [categoryList, setCategoryList] = React.useState(null);

  // Retrieve the knowledge data and query state
  const { data: knowledgeMap, isLoading, isError } = useQuery(fetchKnowledge());

  // Calculate the category list based on changes to the knowledge map
  React.useLayoutEffect(() => {
    if (!knowledgeMap) {
      return;
    }

    setCategoryList(Object.keys(knowledgeMap));
  }, [knowledgeMap]);

  // Set the initial value of the selected category, once the category list is defined
  React.useEffect(() => {
    if (selectedCategory || !categoryList) {
      return;
    }

    setSelectedCategory(categoryList[0]);
  }, [categoryList, selectedCategory]);

  return {
    categoryList,
    isLoading,
    isError,
    knowledgeMap,
    selectedCategory,
    setSelectedCategory
  };
};

export default useKnowledge;
